<template>
    <!-- Hero Start -->
    <section>
        <div class="container-fluid bg-primary hero-header">
            <div class="container">
                <div class="jargen1"></div>
                <!-- <div class="jargen2"></div> -->
                <div class="row g-5 align-items-center">
                    <div class="col-lg-6 text-center text-lg-start title-hero">
                        <!-- <h3 class="fw-light text-white animated slideInRight">{{datasectionSlider.title1}}</h3> -->
                        <h1 class="title-brand animated slideInRight">{{ datasectionSlider.title2 }} <span
                                class="fw-light text-primary">{{ datasectionSlider.title3 }}</span><br>{{ datasectionSlider.title4 }}
                        </h1>
                        <p class="mb-4 animated slideInRight hero-desc">{{ datasectionSlider.desc }}</p>
                        <button @click="$router.push('#about')"
                            class="btn btn-warning py-2 px-4 me-3 animated slideInRight font-weight-bold">{{ datasectionSlider.button1 }}</button>
                        <!-- <a href="" class="btn btn-outline-dark py-2 px-4 animated slideInRight font-weight-bold">{{datasectionSlider.button2}}</a> -->
                    </div>
                    <div class="hero-pil w-lg-100"></div>
                    <div class="col-lg-6 bottle-box wow slideInUp" data-wow-delay="1s"><img
                        class="nad-bottle img-fluid animated pulse infinite" src="assets/img/nad-new.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Hero End -->
</template>

<script>
import axios from 'axios'

export default {
    name: 'SectionSlider',

    data() {
        return {
            show: 0,
            username: null,
            noTelp: '62811959901',
            datasectionSlider: {
                title1: null,
                title2: null,
                title3: null,
                title4: null,
                title5: null,
                desc: null,
                button1: null,
                button2: null,
            },
            styleIphone: {
                marginTop: null
            },
            flagImage: 'flag-id.png',
            paddingTop: null
        }
    },
    mounted() {
        // this.username = window.location.pathname.replace("/", "");
        this.username = this.$route.params.username
        // console.log(this.username)
        if (this.username) {
            axios
                .get(`https://api.bisnisonlinebgs.com/api/content/member/getMemberById/${this.username}`)
                .then(response => {
                    this.noTelp = response.data.data[0].mobile_no
                    // console.log(response.data.data[0].mobile_no)
                });
        }

        if (localStorage.getItem('lang_nad') == null) {
            localStorage.setItem('lang_nad', 'id')
            this.flagImage = 'flag-en.png'
        } else if (localStorage.getItem('lang_nad') == 'id') {
            this.flagImage = 'flag-en.png'
        } else if (localStorage.getItem('lang_nad') == 'en') {
            this.flagImage = 'flag-id.png'
        }

        // if(this.username == ""){
        //     document.getElementById("showLocation").style.display = "block";
        // }else if(this.username !== ""){
        //     document.getElementById("showLocation").style.display = "none";
        // }

        axios.get(`../../lang.json`).then(response => {
            let datasectionSlider
            if (localStorage.getItem('lang_nad') == 'id') {
                datasectionSlider = response.data.id[0];
            } else if (localStorage.getItem('lang_nad') == 'en') {
                datasectionSlider = response.data.en[0];
            }

            this.datasectionSlider.title1 = datasectionSlider.sectionSlider.title1
            this.datasectionSlider.title2 = datasectionSlider.sectionSlider.title2
            this.datasectionSlider.title3 = datasectionSlider.sectionSlider.title3
            this.datasectionSlider.title4 = datasectionSlider.sectionSlider.title4
            this.datasectionSlider.title5 = datasectionSlider.sectionSlider.title5
            this.datasectionSlider.desc = datasectionSlider.sectionSlider.desc
            this.datasectionSlider.button1 = datasectionSlider.sectionSlider.button1
            this.datasectionSlider.button2 = datasectionSlider.sectionSlider.button2
        })

        if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
            this.styleIphone.marginTop = '8px'
            this.paddingTop = '12px'
        }
    },
}
</script>
